<div class="flex h-screen w-screen flex-col items-center justify-center overflow-hidden bg-base-100">
  <div class="loading-medallion h-36 w-36">
    <app-logo class="loading-medallion-logo h-20 w-20"></app-logo>
  </div>
  @if (message) {
    <span class="sr-only" role="status" aria-live="polite">
      {{ message }}
    </span>
  }
</div>
